import { useState } from "react";
import { Slider, Typography, Box } from "@mui/material";
import { QuestionCard, sliderStyles } from "../mobilePreview.style";

type Props = {
  currentQuestion: any;
};

const SliderPreview = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;
  const [value, setValue] = useState(properties?.min ?? 0);

  return (
    <Box sx={{ ...QuestionCard, pt: 3, pb: 4 }}>
      <Box sx={{ px: 1.5 }}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Typography color="primary" variant="h5">
            {value}
          </Typography>
        </Box>
        <Slider
          sx={sliderStyles}
          value={value}
          onChange={(_, val) => setValue(val as number)}
          min={properties?.min}
          max={properties?.max}
          step={properties?.step}
          marks={true}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
        <Typography color="textSecondary">{properties?.minLabel}</Typography>
        <Typography color="textSecondary">{properties?.maxLabel}</Typography>
      </Box>
    </Box>
  );
};

export default SliderPreview;
